import {
  getPrivateSeasonBySlug,
  getSeasonBySlug
} from "./chunk-PFRPPHW3.mjs";
import {
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/hooks/wbk/seasons/detail.ts
import { useQuery } from "@tanstack/react-query";
var useGetSeason = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["useGetSeason", props],
    queryFn: () => {
      if (props.private) {
        return getPrivateSeasonBySlug(props);
      }
      return getSeasonBySlug(props);
    }
  }, options));
};

export {
  useGetSeason
};
//# sourceMappingURL=chunk-D4T2G3OD.mjs.map